import { resourceExplorerWidgetSelector } from "./resourceExplorerWidgetSelector";
import { RootState } from "../../../../store";
import { ResourceExplorerWidget } from "../../../../../services/cloudchipr.api";

export const resourceExplorerWidgetDataSelector = (
  state: RootState,
): ResourceExplorerWidget | undefined => {
  return resourceExplorerWidgetSelector(state)?.data;
};
